export default "__VITE_ASSET__BROeyO_P__"